"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.fill");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.map");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var viewports = ['xs', 'sm', 'md', 'ml', 'lg', 'xl', 'ds'];

var buildFlexPropClassName = function buildFlexPropClassName(prefix, viewport, suffix, value) {
  return "grv-row" + prefix + "--" + viewport + suffix + value;
};

var getFlexPropClassName = function getFlexPropClassName(prop, prefix, suffix) {
  if (prefix === void 0) {
    prefix = '';
  }

  if (suffix === void 0) {
    suffix = '-';
  }

  if (typeof prop === 'object') {
    return Object.entries(prop).map(function (_ref) {
      var viewport = _ref[0],
          value = _ref[1];
      return buildFlexPropClassName(prefix, viewport, suffix, value);
    });
  }

  return viewports.map(function (viewport) {
    return buildFlexPropClassName(prefix, viewport, suffix, prop);
  });
};

var flexPropType = _propTypes["default"].oneOfType([_propTypes["default"].shape({
  ds: _propTypes["default"].string,
  xl: _propTypes["default"].string,
  lg: _propTypes["default"].string,
  ml: _propTypes["default"].string,
  md: _propTypes["default"].string,
  sm: _propTypes["default"].string,
  xs: _propTypes["default"].string
}), _propTypes["default"].string]);

var propTypes = {
  align: flexPropType,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  fill: _propTypes["default"].bool,
  justify: flexPropType,
  margin: flexPropType,
  marginFluid: flexPropType,
  reorder: flexPropType
};
var defaultProps = {
  align: {},
  fill: false,
  justify: {},
  margin: {},
  marginFluid: {},
  reorder: {}
};

var Row = function Row(_ref2) {
  var children = _ref2.children,
      align = _ref2.align,
      justify = _ref2.justify,
      margin = _ref2.margin,
      marginFluid = _ref2.marginFluid,
      fill = _ref2.fill,
      className = _ref2.className,
      reorder = _ref2.reorder,
      otherProps = _objectWithoutPropertiesLoose(_ref2, ["children", "align", "justify", "margin", "marginFluid", "fill", "className", "reorder"]);

  var classes = (0, _classnames["default"])('grv-row', getFlexPropClassName(justify), getFlexPropClassName(align), getFlexPropClassName(margin, '__margin', '--'), getFlexPropClassName(marginFluid, '__margin-fluid', '--'), getFlexPropClassName(reorder), {
    'grv-row--fill': fill
  }, className);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
    className: classes
  }), children);
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
var _default = Row;
exports["default"] = _default;